// client/src/compoents/SearchFilters.js

import React from 'react';
import { Button, Form, ButtonGroup, ToggleButton } from 'react-bootstrap';
import TimeRangeSlider from './common/TimeRangeSlider';
import RadiusSlider from './common/RadiusSlider';

// Helper component for filter sections
const FilterSection = ({ title, children }) => (
  <Form.Group className="mb-4">
    <Form.Label className="fw-bold">{title}</Form.Label>
    {children}
  </Form.Group>
);

const SearchFilters = ({ filters, setFilters, courseCount }) => {
  const handleInputChange = (name, value) => {
    setFilters({ ...filters, [name]: value });
  };

  const handleTimeRangeChange = ([start, end]) => {
    setFilters({ ...filters, startTime: start, endTime: end });
  };

  const handleRadiusChange = (radius) => {
    setFilters({ ...filters, radius });
  };

  // Options for the button groups
  const golferOptions = [
    { name: '1', value: 1 },
    { name: '2', value: 2 },
    { name: '3', value: 3 },
    { name: '4', value: 4 },
  ];

  const holeOptions = [
    { name: '9 Holes', value: 9 },
    { name: '18 Holes', value: 18 },
  ];

  return (
    <div className="h-100 d-flex flex-column p-4 bg-light border-end">
      {/* Results Header */}
      <div className="text-center mb-4 p-3 bg-white rounded shadow-sm">
        <div className="display-1 fw-bold text-dark">{courseCount}</div>
        <p className="text-primary fw-bold mb-0">GOLF COURSES FOUND</p>
      </div>

      <Form className="flex-grow-1">
        {/* Time Range */}
        <FilterSection title="Time Range">
          <TimeRangeSlider
            timeRange={[filters.startTime, filters.endTime]}
            setTimeRange={handleTimeRangeChange}
          />
        </FilterSection>

        {/* Radius */}
        <FilterSection title="Search Radius">
          <RadiusSlider radius={filters.radius} setRadius={handleRadiusChange} />
        </FilterSection>

        {/* Golfers */}
        <FilterSection title="Number of Golfers">
          <ButtonGroup className="w-100">
            {golferOptions.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-golfers-${idx}`}
                type="radio"
                variant="outline-secondary"
                name="golfers"
                value={radio.value}
                checked={filters.golfers === radio.value}
                onChange={(e) => handleInputChange('golfers', parseInt(e.currentTarget.value))}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </FilterSection>

        {/* Holes */}
        <FilterSection title="Holes">
          <ButtonGroup className="w-100">
            {holeOptions.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-holes-${idx}`}
                type="radio"
                variant="outline-secondary"
                name="holes"
                value={radio.value}
                checked={filters.holes === radio.value}
                onChange={(e) => handleInputChange('holes', parseInt(e.currentTarget.value))}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </FilterSection>
      </Form>

      {/* Action Buttons at the bottom */}
      <div className="mt-auto">
        <Button variant="primary" className="w-100 mb-2">
          Find Tee Times
        </Button>
        <Button variant="outline-secondary" className="w-100">
          View All Courses
        </Button>
      </div>
    </div>
  );
};

// Set default props for courseCount
SearchFilters.defaultProps = {
  courseCount: 0,
};


export default SearchFilters;